import React from 'react';
import Select from 'react-select';
import Datepicker from 'react-tailwindcss-datepicker';
import { debounce } from '../../../utils/Debounce';

const TYPE_OPTIONS = [
  { value: '', label: 'All Types' },
  { value: 'image', label: 'Images (Cube)' },
  { value: 'swiper', label: 'Swipe Animated' },
  { value: 'multi_creative_swiper', label: 'Multi Image Swiper' },
  { value: 'upload_file', label: 'Upload HTML File' },
  { value: 'video', label: 'Video Ad' },
  { value: 'gif', label: 'GIF' }
];

function FilterBar({ filterType, setFilterType, filterDateRange, setFilterDateRange, filterSearch, setFilterSearch }) {
  return (
    <div className="flex flex-wrap gap-4 items-center mb-6 px-4 sm:px-6 lg:px-8">
      <div style={{ minWidth: 180 }}>
        <Select
          options={TYPE_OPTIONS}
          value={filterType}
          onChange={setFilterType}
          isSearchable={false}
          classNamePrefix="select"
          placeholder="Type"
        />
      </div>
      <div style={{ minWidth: 260 }}>
        <Datepicker
          value={filterDateRange}
          onChange={setFilterDateRange}
          primaryColor="cyan"
          showShortcuts={true}
          useRange={true}
          placeholder="Created On"
        />
      </div>
      <div>
        <input
          type="text"
          className="rounded-lg border border-gray-300 px-3 py-2"
          placeholder="Search by name"
          onChange={debounce((e) => setFilterSearch(e.target.value), 1500)}
        />
      </div>
    </div>
  );
}

export default FilterBar;
